import EndpointsBase from "../EndpointsBase";
import  { ErrorInfo  } from "react";
class ClientEventEndpoints extends EndpointsBase {
  async logClientEvent(eventName: string, eventData: {}) {
    const request = {
      method: "clientevent",
      headers: this._getAuthHeader(),
      run: this.server.postData,
      data: {
        eventName,
        eventData,
      },
    };

    await this._sendRequest(request);
  }
  async logClientError(error: Error, componentStack: ErrorInfo) {
    const request = {
      method: "clientevent/LogClientError",
      headers: this._getAuthHeader(),
      run: this.server.postData,
      data: {
        error,
        componentStack,
      },
    };

    await this._sendRequest(request);
  }
}

export default new ClientEventEndpoints();
